import { ShoppingBag } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useCart } from '@/context/CartContext';
import { BACKEND_URL } from '@/lib/api';

export const ProductCard = ({ product }) => {
  const { addItem } = useCart();
  const imgSrc = product.image_url
    ? (product.image_url.startsWith('/api') ? `${BACKEND_URL}${product.image_url}` : product.image_url)
    : null;

  return (
    <div
      className="bg-white rounded-sm shadow-sm border border-slate-100 overflow-hidden group hover:shadow-lg transition-all duration-300 flex flex-col h-full"
      data-testid={`product-card-${product.id}`}
    >
      <div className="border-t-4 border-[#0E518D]" />

      {/* Fixer Bildbereich */}
      {imgSrc ? (
        <div className="relative h-56 overflow-hidden bg-slate-50 cursor-pointer shrink-0">
          <img
            src={imgSrc}
            alt={product.name}
            className="w-full h-full object-cover transition-transform duration-300 ease-out group-hover:scale-[1.15]"
          />
          <div className="absolute inset-0 bg-black/0 group-hover:bg-black/5 transition-all duration-300 pointer-events-none" />
        </div>
      ) : (
        <div className="h-56 bg-slate-50 flex items-center justify-center shrink-0">
          <ShoppingBag className="h-12 w-12 text-slate-300" />
        </div>
      )}

      {/* Inhaltsbereich - flex-1 sorgt für gleiche Kartenhöhe */}
      <div className="p-5 flex flex-col flex-1">
        {/* Produktname - eigener Block, max 2 Zeilen */}
        <h3
          className="text-lg font-semibold text-[#1E293B] leading-tight line-clamp-2 min-h-[3.25rem]"
          data-testid={`product-name-${product.id}`}
        >
          {product.name}
        </h3>

        {/* Artikelnummer - eigene Zeile */}
        <p className="text-xs text-slate-400 mt-1 mb-3" data-testid={`product-article-${product.id}`}>
          Art. {product.article_number}
        </p>

        {/* Beschreibung - optional, max 2 Zeilen */}
        {product.description && (
          <p className="text-sm text-[#475569] leading-relaxed line-clamp-2 mb-3">
            {product.description}
          </p>
        )}

        {/* Preis + Button - immer am unteren Rand */}
        <div className="flex items-center justify-between mt-auto pt-3 border-t border-slate-100">
          <span className="text-xl font-bold text-[#0E518D]">{product.price.toFixed(2)} EUR</span>
          <Button
            onClick={() => addItem(product)}
            className="bg-[#0E518D] hover:bg-[#0B4171] text-white rounded-sm uppercase tracking-wide text-xs px-4 py-2 shrink-0"
            data-testid={`add-to-cart-${product.id}`}
          >
            Auswählen
          </Button>
        </div>
      </div>
    </div>
  );
};
